'use client';

import { useState } from 'react';
import { CollapsingField } from '@/shared/ui/CollapsingField/CollapsingField';
import './FeatureBlock.css';
import { IFeatureBlock } from './interfaces';

export const FeatureBlock = ({ element }: IFeatureBlock) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  const text = element.text;

  return (
    <div className={'feature'}>
      <CollapsingField
        title={element.title}
        text={text}
        type="html"
        isOpen={isOpen}
        onToggle={handleToggle}
      />
    </div>
  );
};
